import React, { Fragment, useState } from 'react';
import Breadcrumb from '../../../layout/breadcrumb';
import { Card, Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane, CardHeader } from 'reactstrap';
import { IndexSampling as ComponentSampling } from '../../samplings/IndexSampling';
import { IndexSamplingItems } from '../../samplings/IndexSamplingItems';
import { IndexUser } from '../users/IndexUser';
import { IndexAreas } from '../../areas/IndexAreas';
import { IndexRooms } from '../../areas/IndexRooms';
import { IndexDepartaments } from '../../areas/IndexDepartaments';

export const IndexSampling = (props) => {

    const [activeTab, setActiveTab] = useState("1");

    const toggleTab = tab => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    return (
        <Fragment>
            <Container className="mt--7 p-l-0 p-r-0" fluid>
                <IndexRooms
                    {...{ ...props, activeTab }}
                />



            </Container>
        </Fragment>
    )
}
